<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor de Prestaciones B2B
    </div>
  </div>

  <div class="col-md-12">
    <br>
    <div class="sub-titulo">
      <span class="linea">
        Listado de Prestaciones B2B
      </span>

      <button type="button" class="btn btn-outline-primary botonListar" data-toggle="modal" data-target="#crearB2BType" >
        Agregar Tipo de Acuerdo B2B
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div class="col-12">
    <br>
    <table class="table table-hover">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Titulo</th>
          <th>SubTitulo</th>
          <th>Estado</th>
          <th>Nro Orden</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngFor="let b2bType of b2bAgreementTypeList">
          <td>{{b2bType.agre_typ_id}}</td>
          <td>{{b2bType.agre_typ_title}}</td>
          <td>{{b2bType.agre_typ_subtitle}}</td>
          <td>{{b2bType.agre_typ_status}}</td>
          <td>{{b2bType.agre_typ_weight}}</td>
          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span data-toggle="modal" data-target="#visualizarB2BType" style="cursor: pointer;" (click)="clickB2BType(b2bType)">
                  <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      style="color: #316AD8;" aria-hidden="true" data-mat-icon-type="font">manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!--modal visualizar-->
<div class="modal fade" id="visualizarB2BType" aria-labelledby="exampleModalLabel" 
    aria-hidden="true" #visualizarB2BType>
  <div class="modal-dialog  modal-lg">
    <div class="modal-content" [hidden]="isEdit">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Detalle de Tipo de Acuerdo B2B</p>
          <hr class="estiloHrModal">
          <p class="subTituloModal" style="margin: 0%;width: auto;">Información del Tipo de Acuerdo B2B</p>
          <br>
          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Titulo:</strong> {{b2bAgreementTypeSelected.agre_typ_title}}</p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>SubTitulo:</strong> {{b2bAgreementTypeSelected.agre_typ_subtitle}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Estado:</strong> {{b2bAgreementTypeSelected.agre_typ_status}} </p>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Nro Orden:</strong> {{b2bAgreementTypeSelected.agre_typ_weight}} </p>
            </div>
            <div class="col-6" *ngIf="b2bAgreementTypeSelected.agre_typ_svg">
              <p class="letraNormalModal"><strong>Imagen:</strong>
                <img  class="svgItem" style="width: 40%;" [src]="URL_DOCS + b2bAgreementTypeSelected.agre_typ_svg	 | safeUrl" />
              </p>
            </div>
          </div>
          <hr class="estiloHrModal">
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
            <button type="button" class="primary buttonStyleSecondary" (click)="editB2BType()" >Editar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-content" [hidden]="!isEdit">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Editar Tipo de Acuerdo B2B</p>
          <hr class="estiloHrModal">

          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Titulo:</strong> </p>
              <input type="text" class="form-control" [(ngModel)]="b2bAgreementTypeSelected.agre_typ_title">
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>SubTitulo:</strong> </p>
              <input type="text" class="form-control" [(ngModel)]="b2bAgreementTypeSelected.agre_typ_subtitle">
            </div>
            <div class="col-6">
              <br>
              <div class="form-check">
                <input class="form-check-input"
                      type="checkbox"
                      id="beneficioCheck"
                      [(ngModel)]="b2bAgreementTypeSelected.agre_typ_status_bool">
                
                <label class="form-check-label" for="beneficioCheck">
                  Activa
                </label>
              </div>
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Nro Orden:</strong> </p>
              <select class="form-control" [(ngModel)]="b2bAgreementTypeSelected.agre_typ_weight">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Imagen actual:</strong></p>
              <img class="svgItem" style="width: 40%;" [src]="URL_DOCS + b2bAgreementTypeSelected.agre_typ_svg | safeUrl" 
                *ngIf="b2bAgreementTypeSelected.agre_typ_svg && !imagePreview">
            </div>

            <div class="col-6">
              <p class="letraNormalModal"><strong>Cambiar Imagen:</strong></p>
              <input type="file" (change)="onFileSelected($event)" accept="image/*" class="form-control">
            </div>

            <div class="col-12" *ngIf="imagePreview">
              <p class="letraNormalModal"><strong>Vista previa:</strong></p>
              <img [src]="imagePreview" style="width: 40%; border: 1px solid #ccc; padding: 5px;">
              <br><br>
              <button class="btn btn-outline-danger" (click)="clearSelectedImage()">Quitar imagen seleccionada</button>
            </div>

            <div class="col-12" *ngIf="imageError" style="color: red;">
              {{ imageError }}
            </div>

          </div>

          <div style="display: flex; justify-content: center; align-items: center; gap: 15px; padding: 10px;">
            <button type="button"
              class="boton-accion colorLetraVolver" 
              (click)="updateB2BType()"
              [disabled]="isLoading" 
            >
            <span *ngIf="!isLoading">Guardar</span>
            <span *ngIf="isLoading">Guardando...</span>
          </button>
          
            <button type="button"
              class="boton-accion colorLetraVolver" 
              (click)="cancelEditB2BType()" 
              [disabled]="isLoading"
            >Cancelar
          </button>
          </div>
        </div>
      </div>

      <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>

    </div>
  </div>
</div>
<!--modal visualizar-->